<template>
  <div class="patentList fatherHeight contBox">
    <div class="bar-title">查询条件</div>
    <div>
      <div class="search-top">
        <el-form
            ref="searchForm"
            :inline="true"
            :model="searchData"
            class="demo-form-inline"
            label-suffix=":"
        >
          <el-form-item label="时间范围">
            <el-date-picker
                v-model="searchData.time"
                clearable
                format="YYYY-MM-DD"
                placeholder="请选择"
                range-separator="-"
                type="daterange"
                value-format="YYYY-MM-DD"
                @change="handleTimeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
                v-model="searchData.name"
                clearable
                placeholder="姓名"
                @input="searchInput"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="color-main" type="primary" @click="resetForm">
              <i class="fa fa-refresh"></i>重置
            </el-button>
            <el-button class="color-main" type="primary" @click="handleSearch">
              <i class="fa fa-search"></i>查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-divider></el-divider>
    <div ref="tableBoxRef" class="patientList">
      <div class="list-top flex-between">
        <div class="bar-title">日结明细</div>
        <div>
          <!--
          <el-button class="color-yellow" v-print="print">
            <i class="fa fa-print"></i>
            打印全部
          </el-button>
          -->
          <el-button class="color-vice" @click="exportTable">
            <i class="fa fa-file-text-o"></i>
            导出
          </el-button>
        </div>
      </div>
      <div id="printArea" ref="printView" class="table">
        <div class="patentList fatherHeight contBox">
          <div class="box-info">
            <el-table
                v-if="istable"
                v-loading="dataListLoading"
                :data="tableData"
                :row-class-name="tableRowClassName"
                border
                size="small"
                style="width: 100%"
            >
              <el-table-column align="center" fixed label="序号" min-width="60" type="index"/>
              <el-table-column label="姓名" prop="psn_name" width="80"/>
              <el-table-column label="身份证号" prop="cert_no" width="180"/>
              <el-table-column label="病历号" prop="patient_id" width="80"/>
              <el-table-column label="发票号" prop="bed_reg_id" width="80"/>
              <el-table-column label="医保类型" prop="insutype" width="80"/>
              <el-table-column label="结算时间" prop="setl_time" width="120"/>
              <el-table-column label="医疗费总额" prop="medfee_sumamt" width="100"/>
              <el-table-column label="西药" prop="xy_fee" width="80"/>
              <el-table-column label="中成药" prop="zcy_fee" width="80"/>
              <el-table-column label="材料费" prop="cl_fee" width="80"/>
              <el-table-column label="透析-血液透析" prop="tx_fee" width="120"/>
              <el-table-column label="透析-血液透析滤过" prop="lg_fee" width="140"/>
              <el-table-column label="透析-血液灌流" prop="gl_fee" width="120"/>
              <el-table-column label="检验-实验室" prop="sy_fee" width="100"/>
              <el-table-column label="护理" prop="hl_fee" width="80"/>
              <el-table-column label="治疗费" prop="zl_fee" width="80"/>
              <el-table-column label="一般诊疗费" prop="ybzl_fee" width="90"/>
              <el-table-column label="报销金额" prop="fund_pay_sumamt" width="100"/>
              <el-table-column label="自费金额" prop="psn_cash_pay" width="100"/>
              <el-table-column label="现金" prop="cash_fee" width="80"/>
              <el-table-column label="微信" prop="wechat_fee" width="80"/>
              <el-table-column label="支付宝" prop="ali_fee" width="80"/>
              <el-table-column label="银行卡" prop="bank_fee" width="80"/>
              <el-table-column label="医保卡" prop="medi_card_fee" width="80"/>
              <el-table-column label="电子医保码" prop="medi_code_fee" width="100"/>
            </el-table>
            <el-descriptions
                :column="5"
                border
                size="small"
                style="margin-top: 16px"
                title="日结统计"
            >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="结算人数"
                  label-class-name="my-label"
              >{{ info.patient_count }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="结算笔数"
                  label-class-name="my-label"
              >{{ info.settle_count }}
              </el-descriptions-item
              >

              <el-descriptions-item
                  content-class-name="my-content"
                  label="医疗费总额"
                  label-class-name="my-label"
              >{{ info.total_med_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="西药"
                  label-class-name="my-label"
              >{{ info.total_xy_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="中成药"
                  label-class-name="my-label"
              >{{ info.total_zcy_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="材料费"
                  label-class-name="my-label"
              >{{ info.total_cl_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="透析-血液透析"
                  label-class-name="my-label"
              >{{ info.total_tx_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="透析-血液透析滤过"
                  label-class-name="my-label"
              >{{ info.total_lg_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="透析-血液灌流"
                  label-class-name="my-label"
              >{{ info.total_gl_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="检验-实验室"
                  label-class-name="my-label"
              >{{ info.total_sy_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="护理"
                  label-class-name="my-label"
              >{{ info.total_hl_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="治疗费"
                  label-class-name="my-label"
              >{{ info.total_zl_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="一般诊疗费"
                  label-class-name="my-label"
              >{{ info.total_ybzl_fee }}
              </el-descriptions-item
              >

              <el-descriptions-item
                  content-class-name="my-content"
                  label="报销金额"
                  label-class-name="my-label"
              >{{ info.total_fund_fee }}
              </el-descriptions-item
              >

              <el-descriptions-item
                  content-class-name="my-content"
                  label="自费金额"
                  label-class-name="my-label"
              >{{ info.total_psn_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="现金"
                  label-class-name="my-label"
              >{{ info.total_cash_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="微信"
                  label-class-name="my-label"
              >{{ info.total_wechat_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="支付宝"
                  label-class-name="my-label"
              >{{ info.total_ali_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="银行卡"
                  label-class-name="my-label"
              >{{ info.total_bank_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="医保卡"
                  label-class-name="my-label"
              >{{ info.total_medi_card_fee }}
              </el-descriptions-item
              >
              <el-descriptions-item
                  content-class-name="my-content"
                  label="电子医保码"
                  label-class-name="my-label"
              >{{ info.total_medi_code_fee }}
              </el-descriptions-item
              >
            </el-descriptions>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getCurrentInstance, nextTick, onMounted, reactive, toRefs,} from 'vue'
import service from '@/utils/request'
import {Antishake, downLoadXlsx, TimestampToTime} from '@/utils/tool'

export default {
  name: 'patentList',
  setup() {
    const {proxy} = getCurrentInstance()
    const state = reactive({
      searchData: {
        start_time: '',
        end_time: '',
        name: '',
      },
      print: {
        id: 'printArea',
        popTitle: '月结明细',
      },
      pageData: {
        currentPage: 1,
        pageSize: 10,
        totalSum: 0,
      },
      dataListLoading: false,
      tableData: [],
      tableHei: 0,
      istable: false,
      tableBoxRef: null,
      info: '',
    })
    onMounted(() => {
      state.searchData.start_time = TimestampToTime()
      state.searchData.end_time = TimestampToTime()
      state.searchData.time = [
        state.searchData.start_time,
        state.searchData.end_time,
      ]
      state.istable = false
      state.tableHei = state.tableBoxRef.clientHeight - 240
      console.log(state.tableHei)
      nextTick(() => {
        state.istable = true
      })
      getDataList()
    })
    const handleSizeChange = (val) => {
      state.pageData.pageSize = val
      getDataList()
    }

    const handleCurrentChange = (val) => {
      state.pageData.currentPage = val
      getDataList()
    }
    const searchInput = () => {
      Antishake(search(), 2000)
    }
    const resetForm = () => {
      state.searchData.day_time = TimestampToTime()
      handleSearch()
    }
    const handleSearch = () => {
      state.pageData.currentPage = 1
      getDataList()
    }

    const getDataList = async () => {
      state.dataListLoading = true
      let res = await service.post('/api/settle/getDaySettle', state.searchData)
      state.dataListLoading = false
      if (res.code === 0) {
        state.info = res.data
        state.tableData = res.data.settle_list
      }
    }

    const handleTimeChange = (e) => {
      state.searchData.start_time = e[0]
      state.searchData.end_time = e[1]
    }

    const exportTable = (row) => {
      let title = `日结明细导出.xlsx`
      downLoadXlsx('/api/settle/exportSettleList', state.searchData, title)
    }
    const printFile = () => {
      proxy.$print(proxy.$refs.printView)
    }
    const tableRowClassName = ({row}) => {
      if (row.check_total == false) {
        return 'danger-row'
      } else if (row.check_cash == false) {
        return 'warning-row'
      }
      return ''
    }
    return {
      ...toRefs(state),
      handleSizeChange,
      handleCurrentChange,
      handleSearch,
      handleTimeChange,
      getDataList,
      resetForm,
      exportTable,
      printFile,
      tableRowClassName,
      searchInput
    }
  },
}
</script>
<style lang="scss">
.el-notification__group {
  flex: 1;
}

.notice_but {
  text-align: right;
  color: #3167a8;
  cursor: pointer;
}

.el-table .warning-row {
  background: #fff3e0;
}

.el-table .danger-row {
  background: #ffebee;
}
</style>
<style lang="scss" scoped>
::v-deep .my-label {
  background-color: rgba(49, 102, 174, 0.1) !important;
  border: 1px solid #e4e9f8 !important;
  color: #3166ae !important;
  font-weight: 400 !important;
}

::v-deep .my-content {
  background: #fde2e2;
}

.demo-form-inline {
  margin-top: 0;
  //flex: 1;
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: repeat(1, 40px);
  align-items: center;

  .el-form-item {
    margin-bottom: 0;
  }
}

.search-top .w-208 {
  width: 208px;
}

.table-tag {
  margin-right: 8px;
}

.fa-stack {
  width: 24px;
  height: 24px;
  cursor: pointer;
  float: right;

  .fa-stack-2x {
    font-size: 24px;
    color: rgba(49, 102, 174, 0.1);
  }

  .fa-stack-1x {
    font-size: 12px;
    color: #3166ae;
    line-height: 24px;
  }
}

.tagBox {
  display: flex;
  justify-content: flex-start;

  // margin-bottom: 10px;
  .tit {
    width: 83px;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Bold';
    font-weight: bold;
    color: #666666;
  }

  .cont {
    width: calc(100% - 83px);
  }
}

.patientList {
  margin-top: 4px;
  height: calc(100% - 150px);
}

.list-top {
  .name {
    font-size: 18px;
    font-family: 'Source Han Sans CN-Medium';
    font-weight: 500;
    color: #000000;
    line-height: 32px;
  }
}

.patient-alert {
  background: rgba(49, 102, 174, 0.1);
  border-radius: 4px 4px 4px 4px;
  font-size: 18px;
  color: #3166ae;
  margin-top: 8px;
  padding: 4px 16px;

  .el-alert__icon {
    color: #3166ae;
  }

  &:deep(.el-alert__content) {
    position: relative;
    top: 3px;
  }
}

.table {
  margin-top: 10px;
  height: calc(100% - 10px);

  .img {
    width: 25px;
    height: 24px;
    margin-right: 14px;
  }
}

.searchBut {
  width: 100%;
  display: flex;
  justify-content: end;
  margin-right: 28px;
}

.del {
  background-color: #ffecec;
  color: #ff6b6b;
  font-weight: 700;
}

.modify {
  background-color: #3166ae;
}

.bar-title {
  font-size: 18px;
  line-height: 18px;
  color: #000000;
  border-left: 6px solid #3166ae;
  padding: 0 18px;
  margin-bottom: 16px;
  font-weight: bold;
}

.labelSet1 {
  width: 60px;
  height: 30px;
  line-height: 30px;
  display: block;
  text-align: center;
  color: #fff;
  border-radius: 5px;
}

.psckset {
  background-color: #409eff;
}

.psckset1 {
  background-color: #a4cef8;
  color: #1581fc;
  border: 1px solid #1581fc;
}

.lcsyset {
  background-color: #c6f1b1;
  color: #3bb207;
  border: 1px solid #5bd324;
}

.lcsyset1 {
  background-color: #f1beb1;
  color: #f35c0c;
  border: 1px solid #f35c0c;
}

.info-table {
  width: 100%;
  margin: 10px 0;

  tr {
    height: 40px;
  }

  td {
    padding-left: 20px;
  }

  .color-blue {
    color: #3166ae;
    font-size: 14px;
    width: 230px;
  }

  .border-right {
    /* border-right: 1px solid gray; */
  }
}

.info-table tr:nth-child(2n + 1) {
  background-color: rgba(49, 102, 174, 0.1);
}

.momey-total {
  display: flex;
  margin: 10px;
  line-height: 30px;
  font-size: 14px;

  .item {
    margin-right: 20px;
    width: 150px;
    color: #444;
  }
}

.momey-total1 {
  display: flex;
  margin: 10px;
  line-height: 30px;
  font-size: 14px;

  .item1 {
    margin-right: 20px;
    width: 350px;
    color: #444;
  }

  .item {
    margin-right: 20px;
    width: 250px;
    color: #444;
  }
}
</style>
